import { LOCALE } from '@/js/api/const.ts';
import { MaskInput } from 'maska';

const PHONE_PATTERN = {
  ru: '+7 (###) ### ## ##',
  uz: '+998-##-###-##-##',
} as const;
const PLACEHOLDER_PHONE = {
  ru: '+7 (___) ___ __ __',
  uz: '+998 __ ___ __ __',
} as const;
const PHONE_NUMBERS_LENGTH = {
  ru: PHONE_PATTERN.ru.length,
  uz: PHONE_PATTERN.uz.length,
} as const;
const telInputElements = document.querySelectorAll<HTMLInputElement>('input[type="tel"]');

export function getPhonePattern() {
  if (LOCALE === 'uz') {
    return PHONE_PATTERN.uz;
  }
  return PHONE_PATTERN.ru;
}
export function getPhonePlaceholder() {
  if (LOCALE === 'uz') {
    return PLACEHOLDER_PHONE.uz;
  }
  return PLACEHOLDER_PHONE.ru;
}
function getPhoneNumbersLength() {
  if (LOCALE === 'uz') {
    return PHONE_NUMBERS_LENGTH.uz;
  }
  return PHONE_NUMBERS_LENGTH.ru;
}
export function getPhoneRegularExpression() {
  const length = getPhoneNumbersLength();
  return `^.{${length}}$`;
}

function applyPhoneValidation(input: HTMLInputElement) {
  input.pattern = getPhoneRegularExpression();
}

for (const input of telInputElements) {
  new MaskInput(input, { mask: getPhonePattern() });
  applyPhoneValidation(input);
}
